import Icon from '../components/Icon.vue'

Icon.register({
  'utensil-spoon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480.1 31.9c55.1 55 34.5 164.9-28.5 227.8-49.3 49.3-110 55.1-160.4 28.8l-192.4 214.4c-10.4 11.6-28.5 12.1-39.5 1.1l-51.3-51.3c-11.1-11-10.6-29 1-39.5l214.5-192.4c-26.3-50.4-20.5-111.1 28.8-160.4 62.9-63 172.8-83.6 227.8-28.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/utensil-spoon.js
// module id = 2082
// module chunks = 0